module.exports = __webpack_public_path__ + "img/scene.80a2aa59.png";